"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GqlKetoCardDrivers = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
require("core-js/modules/es6.array.filter.js");
require("core-js/modules/es6.array.map.js");
var _isNumber2 = _interopRequireDefault(require("lodash/isNumber"));
var _capitalize2 = _interopRequireDefault(require("lodash/capitalize"));
var _kebabCase2 = _interopRequireDefault(require("lodash/kebabCase"));
var _isEmpty3 = _interopRequireDefault(require("lodash/isEmpty"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _apollo = require("@nerdwallet/apollo");
var _impression = require("@nerdwallet/analytics/react/impression");
var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));
var _deprecate = require("@nerdwallet/deprecate");
var _reactMarketplaceStarRating = require("@nerdwallet/react-marketplace-star-rating");
var _drivers = require("@nerdwallet/marketplace/constants/drivers");
var _reactQuickFacts = _interopRequireWildcard(require("@nerdwallet/react-quick-facts"));
var _Box = require("@nerdwallet/currency/components/Box");
var _Tooltip = require("@nerdwallet/currency/components/Tooltip");
var _Type = require("@nerdwallet/currency/components/Type");
var _variables = require("@nerdwallet/base-styles/variables");
var _nwAuthTools = require("../lib/utils/nw-auth-tools");
var _ketoBonusQuickFactLto = _interopRequireDefault(require("./keto-bonus-quick-fact-lto"));
var _ketoProductCardModule = _interopRequireDefault(require("./keto-product-card.module.css"));
var _likelihoodOfApprovalCta = _interopRequireDefault(require("../likelihood-of-approval-cta"));
var _constants = require("../lib/constants");
var _utils = require("../lib/utils");
var _CreditScoreWidget = require("../creditscore_pill/CreditScoreWidget");
var _templateObject;
// copied from @nerdwallet/likelihood-of-approval
var CREDIT_DASHBOARD_PATH_WITH_TRK = '/home/dashboard/credit-score?trk_channel=web&trk_element=hyperlink&trk_location=likelihood_of_approval';
var AO_COLORS = {
  DEFAULT: _variables.colors['neutral-lighter'],
  DEFAULT_BACKGROUND: _variables.colors['neutral-lightest'],
  LOW: _variables.colors['red-light'],
  MEDIUM: _variables.colors.yellow,
  HIGH: _variables.colors['green-dark']
};
var AO_RANGES = {
  LOW: {
    min: 0,
    max: 0.45
  },
  MEDIUM: {
    min: 0.45,
    max: 0.65
  },
  HIGH: {
    min: 0.65,
    max: 1
  }
};

// copied from @nerdwallet/likelihood-of-approval
var getColorAndLabel = function getColorAndLabel(props) {
  var approvalOdds = props.approvalOdds;
  if (approvalOdds < AO_RANGES.LOW.max) {
    return {
      color: AO_COLORS.LOW,
      label: 'poor'
    };
  }
  if (approvalOdds >= AO_RANGES.MEDIUM.min && approvalOdds < AO_RANGES.MEDIUM.max) {
    return {
      color: AO_COLORS.MEDIUM,
      label: 'good'
    };
  }
  if (approvalOdds >= AO_RANGES.HIGH.min) {
    return {
      color: AO_COLORS.HIGH,
      label: 'excellent'
    };
  }
  return {
    color: AO_COLORS.DEFAULT,
    label: ''
  };
};
var TRANSUNION_LOGO_CTA = /*#__PURE__*/_react.default.createElement("a", {
  href: CREDIT_DASHBOARD_PATH_WITH_TRK,
  target: "_",
  className: (0, _classes.default)('display-block')
}, /*#__PURE__*/_react.default.createElement("div", {
  className: (0, _classnames.default)('tu-logo', _ketoProductCardModule.default.tuLogo)
}));
var KetoQuickFacts = function KetoQuickFacts(_ref) {
  var analytics = _ref.analytics,
    enableAnalytics = _ref.enableAnalytics,
    quickFacts = _ref.quickFacts,
    isLTODynamicPlacement = _ref.isLTODynamicPlacement;
  (0, _deprecate.useDeprecatedPropsWarning)({
    component: 'KetoQuickFacts',
    deprecatedProps: [{
      version: '6.9.0',
      deprecated: 'enableAnalytics',
      migration: 'Use analytics instead.'
    }],
    props: {
      enableAnalytics: enableAnalytics
    }
  });
  var quickFactComponents = [];
  var filteredQuickFacts = quickFacts.filter(function (quickFact) {
    return quickFact && !(0, _isNil2.default)(quickFact.value);
  });
  if ((0, _isEmpty3.default)(filteredQuickFacts)) {
    return null;
  }
  filteredQuickFacts.forEach(function (quickFact) {
    quickFactComponents.push( /*#__PURE__*/_react.default.createElement("div", {
      key: "".concat(quickFact.id, "-value"),
      className: (0, _classnames.default)(_ketoProductCardModule.default.driversRow)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)([_ketoProductCardModule.default.cell, _ketoProductCardModule.default.label])
    }, quickFact.labelTooltip ? /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
      id: quickFact.id,
      label: quickFact.label,
      content: /*#__PURE__*/_react.default.createElement("span", {
        className: _ketoProductCardModule.default.tooltipContent
      }, quickFact.labelTooltip),
      title: "More information about ".concat(quickFact.label)
    }) : quickFact.label), isLTODynamicPlacement && quickFact.label === 'Bonus' ? /*#__PURE__*/_react.default.createElement(_ketoBonusQuickFactLto.default, {
      quickFact: quickFact
    }) : /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)([_ketoProductCardModule.default.cell, _ketoProductCardModule.default.value])
    }, /*#__PURE__*/_react.default.createElement(_reactQuickFacts.QuickFactValue, {
      analytics: analytics,
      enableAnalytics: enableAnalytics || !(0, _isEmpty3.default)(analytics),
      quickFact: quickFact
    }))));
  });
  return quickFactComponents;
};
var GqlKetoCardDrivers = function GqlKetoCardDrivers(_ref2) {
  var analytics = _ref2.analytics,
    approvalLikelihood = _ref2.approvalLikelihood,
    approvalOddsEnabled = _ref2.approvalOddsEnabled,
    className = _ref2.className,
    driversOverrides = _ref2.driversOverrides,
    DriverRenderer = _ref2.driversRenderer,
    gqlMarketplaceEntity = _ref2.gqlMarketplaceEntity,
    identity = _ref2.identity,
    legacyTrkProps = _ref2.legacyTrkProps,
    omitRating = _ref2.omitRating,
    reviewLinkOverride = _ref2.reviewLinkOverride,
    showMatchScoreCTA = _ref2.showMatchScoreCTA,
    showNotYetRated = _ref2.showNotYetRated,
    shouldOmitCreditScoreDriver = _ref2.shouldOmitCreditScoreDriver,
    showCreditScorePill = _ref2.showCreditScorePill;
  /*
   * @todo https://nerdwallet.atlassian.net/browse/RUR-532 to get the actual matchScore
   * Leaving this for now because the field will be defined in the styleguide but will be undefined
   * for the client.
   */
  var creditScoreComparisonContent = gqlMarketplaceEntity.creditScoreComparisonContent,
    matchScore = gqlMarketplaceEntity.matchScore,
    maxFico = gqlMarketplaceEntity.maxFico,
    minFico = gqlMarketplaceEntity.minFico,
    placementDrivers = gqlMarketplaceEntity.placementDrivers,
    recommendedCreditScoreRangeDetails = gqlMarketplaceEntity.recommendedCreditScoreRangeDetails,
    starRating = gqlMarketplaceEntity.starRating,
    limitedCreditHistory = gqlMarketplaceEntity.limitedCreditHistory;
  if ((0, _isEmpty3.default)(placementDrivers) && (0, _isEmpty3.default)(driversOverrides)) {
    return null;
  }

  // respect overrides, even if the overrides are an empty array.
  var drivers = driversOverrides || placementDrivers;
  var quickFacts = drivers.map(function (_ref3) {
    var description = _ref3.description,
      label = _ref3.label,
      value = _ref3.value,
      valueTooltip = _ref3.valueTooltip,
      valueTooltipHasHtml = _ref3.valueTooltipHasHtml;
    var valueHelpText;
    if (valueTooltip && valueTooltipHasHtml) {
      /* eslint-disable react/no-danger */
      valueHelpText = /*#__PURE__*/_react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: valueTooltip
        }
      });
      /* eslint-enable react/no-danger */
    } else {
      valueHelpText = valueTooltip;
    }
    return {
      id: (0, _kebabCase2.default)(label),
      label: label,
      value: value !== null && value !== void 0 ? value : 'N/A',
      description: /*#__PURE__*/_react.default.createElement(DriverRenderer, null, description),
      valueTooltip: valueHelpText,
      valueSize: 'medium'
    };
  });

  // the following quick facts will always be included based on the conditional logic.
  // if the desire is to remove these at any time to actually complete respect an override then
  // just wrap all of this in an if statement checking if using overrides or not.

  if (!shouldOmitCreditScoreDriver) {
    var creditScoreRange = recommendedCreditScoreRangeDetails.creditScoreRange,
      creditScoreRangeDescription = recommendedCreditScoreRangeDetails.description;
    if (showMatchScoreCTA) {
      if (minFico && maxFico) {
        quickFacts.push({
          id: 'recommendedCreditScoreRange',
          label: 'Rec Credit Score',
          value: creditScoreRange || null,
          valueSize: _drivers.VALUE_SIZES.MEDIUM,
          description: creditScoreRangeDescription
        });
      }
    } else {
      /**
       * all logic taken from
       * https://github.com/NerdWallet/react-components/blob/master/components/quick-facts/src/mappings/credit-cards.jsx#L169
       */
      // eslint-disable-next-line no-lonely-if
      var approvalOdds = approvalLikelihood;
      var loaLabel = 'Recommended Credit Score';
      var loaLabelTooltip;
      var loaValue;
      var loaValueTooltip;
      var creditScore = (0, _nwAuthTools.getCreditScore)(identity);
      if (approvalOddsEnabled && approvalOdds && creditScore) {
        var approvalOddsText = getColorAndLabel({
          approvalOdds: approvalOdds
        }).label;
        loaValue = /*#__PURE__*/_react.default.createElement(_impression.Impression, {
          className: _ketoProductCardModule.default.loaValueWrapper,
          entityName: "cc_approval_odds",
          eventType: "approval_odds_element_impression",
          payload: {
            section_name: analytics === null || analytics === void 0 ? void 0 : analytics.sectionName,
            section_position: analytics === null || analytics === void 0 ? void 0 : analytics.sectionPosition,
            additional_attributes: {
              approval_odds: approvalOddsText
            }
          }
        }, (0, _capitalize2.default)(approvalOddsText));
        loaLabel = 'Your approval odds';
        loaValueTooltip = /*#__PURE__*/_react.default.createElement(_Box.Box, {
          className: _ketoProductCardModule.default.popoverContent
        }, /*#__PURE__*/_react.default.createElement(_Type.Type, {
          size: 1
        }, "We think your odds of getting approved for this card are", /*#__PURE__*/_react.default.createElement(_Type.Type, {
          size: 1,
          bold: true,
          className: _ketoProductCardModule.default.popoverOdds
        }, "\xA0", getColorAndLabel({
          approvalOdds: approvalOdds
        }).label, "\xA0"), "based on your credit score and other factors. That said, these odds are an estimate to help you narrow your choices, not a guarantee. Card issuers may use different criteria than we do."));
      } else if ((!approvalOdds || !approvalOddsEnabled) && creditScore) {
        // note that @quick-fact-max-width is limiting the full extension of the loavalue for desktop in the current grid layout
        loaValue = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classes.default)('display-flex')
        }, /*#__PURE__*/_react.default.createElement("div", null, creditScore), /*#__PURE__*/_react.default.createElement("div", null, TRANSUNION_LOGO_CTA)), /*#__PURE__*/_react.default.createElement("div", null, "(".concat(creditScoreRange, ")")));
        loaLabelTooltip = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_Type.Type, {
          className: (0, _classes.default)(['color-neutral-darkest', 'margin-bottom-2']),
          component: "p",
          size: "1"
        }, "You're", /*#__PURE__*/_react.default.createElement("strong", null, " ".concat(creditScoreComparisonContent === null || creditScoreComparisonContent === void 0 ? void 0 : creditScoreComparisonContent.pointDifference)), " ".concat(creditScoreComparisonContent === null || creditScoreComparisonContent === void 0 ? void 0 : creditScoreComparisonContent.relativeScoreLabel, " suggested score of "), /*#__PURE__*/_react.default.createElement("strong", null, creditScoreComparisonContent === null || creditScoreComparisonContent === void 0 ? void 0 : creditScoreComparisonContent.scoreToCompare), "."), /*#__PURE__*/_react.default.createElement(_Type.Type, {
          className: (0, _classes.default)(['color-neutral-darkest']),
          component: "p",
          size: "1"
        }, "But, heads up, being within the recommended range doesn\u2019t guarantee approval. Credit score is only one factor lenders consider and they may not use the TransUnion Vantage Score like we do."));
      } else {
        var _isEmpty2;
        var loaTooltipContent = (0, _utils.getLoaTooltipContent)(identity, approvalOddsEnabled);
        var loaCtaText = approvalOddsEnabled ? _constants.SEE_YOUR_APPROVAL_ODDS : _constants.GET_YOUR_FREE_CREDIT_SCORE;
        var creditScoreComponent = showCreditScorePill ? /*#__PURE__*/_react.default.createElement(_CreditScoreWidget.CreditScoreWidget, {
          minFico: minFico,
          maxFico: maxFico,
          limitedCreditHistory: limitedCreditHistory,
          analytics: analytics
        }) : /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classes.default)('display-flex--wide')
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classes.default)('margin-right-1')
        }, creditScoreRange), /*#__PURE__*/_react.default.createElement("div", null, "(".concat(creditScoreRangeDescription, ")")));
        loaValue = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, creditScoreComponent, /*#__PURE__*/_react.default.createElement(_likelihoodOfApprovalCta.default, {
          analytics: analytics === null || analytics === void 0 ? void 0 : analytics.loaCtaProps,
          approvalOddsEnabled: approvalOddsEnabled,
          ctaText: loaCtaText,
          enableAnalytics: (_isEmpty2 = !(0, _isEmpty3.default)(analytics)) !== null && _isEmpty2 !== void 0 ? _isEmpty2 : true,
          isKetoCard: true,
          tooltipLabel: loaLabel,
          tooltipContent: loaTooltipContent
        }));
      }
      quickFacts.push({
        id: 'likelihoodOfApproval',
        label: loaLabel,
        labelTooltip: loaLabelTooltip,
        value: loaValue || null,
        valueSize: _drivers.VALUE_SIZES.MEDIUM,
        valueTooltip: loaValueTooltip
      });
    }
  }
  if (!omitRating && matchScore && showMatchScoreCTA) {
    quickFacts.unshift({
      id: 'starRating',
      label: 'NerdWallet rating',
      value: !showNotYetRated && !(0, _isNumber2.default)(starRating) ? null : /*#__PURE__*/_react.default.createElement(_reactMarketplaceStarRating.GraphQlMarketplaceStarRating, {
        analytics: analytics,
        className: (0, _classnames.default)((0, _classes.default)('display-inline-flex')),
        marketplaceEntity: gqlMarketplaceEntity,
        layout: _reactMarketplaceStarRating.LAYOUTS.SMALL_NUMERIC,
        omitRatingNumberHref: false,
        reviewLinkOverride: reviewLinkOverride,
        showNotYetRated: showNotYetRated,
        trkLocation: _constants.TRK_PRODUCT_LOCATION,
        trkPageType: legacyTrkProps === null || legacyTrkProps === void 0 ? void 0 : legacyTrkProps.trkPageType,
        trkTaxonomy: legacyTrkProps === null || legacyTrkProps === void 0 ? void 0 : legacyTrkProps.trkTaxonomy
      }),
      valueSize: _drivers.VALUE_SIZES.MEDIUM,
      valueTooltip: _reactMarketplaceStarRating.TOOLTIP_TEXT.credit_cards
    });
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(KetoQuickFacts, {
    analytics: analytics,
    enableAnalytics: !(0, _isEmpty3.default)(analytics),
    quickFacts: quickFacts
  }));
};
exports.GqlKetoCardDrivers = GqlKetoCardDrivers;
if (process.env.NODE_ENV !== 'production') {
  var _LikelihoodOfApproval, _LikelihoodOfApproval2;
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');
  GqlKetoCardDrivers.propTypes = {
    analytics: PropTypes.shape({
      entityName: PropTypes.string,
      sectionName: PropTypes.string,
      sectionPosition: PropTypes.number,
      loaCtaProps: (_LikelihoodOfApproval = _likelihoodOfApprovalCta.default === null || _likelihoodOfApprovalCta.default === void 0 ? void 0 : (_LikelihoodOfApproval2 = _likelihoodOfApprovalCta.default.props) === null || _LikelihoodOfApproval2 === void 0 ? void 0 : _LikelihoodOfApproval2.analytics) !== null && _LikelihoodOfApproval !== void 0 ? _LikelihoodOfApproval : PropTypes.shape({})
    }),
    approvalLikelihood: PropTypes.number,
    approvalOddsEnabled: PropTypes.bool,
    className: PropTypes.string,
    driversOverrides: PropTypes.arrayOf({
      description: PropTypes.string,
      label: PropTypes.string,
      value: PropTypes.string,
      valueTooltip: PropTypes.string,
      valueTooltipHasHtml: PropTypes.bool
    }),
    driversRenderer: PropTypes.func,
    gqlMarketplaceEntity: PropTypes.shape({
      approvalLikelihood: PropTypes.number,
      creditScoreComparisonContent: PropTypes.shape({
        pointDifference: PropTypes.string,
        relativeScoreLabel: PropTypes.string,
        scoreToCompare: PropTypes.number
      }),
      matchScore: PropTypes.number,
      maxFico: PropTypes.number,
      minFico: PropTypes.number,
      placementDrivers: PropTypes.arrayOf({
        description: PropTypes.string,
        label: PropTypes.string,
        value: PropTypes.string,
        valueTooltip: PropTypes.string,
        valueTooltipHasHtml: PropTypes.bool
      }),
      recommendedCreditScoreRangeDetails: PropTypes.shape({
        creditScoreRange: PropTypes.string,
        description: PropTypes.string
      }),
      starRating: PropTypes.number
    }),
    identity: PropTypes.oneOfType([PropTypes.shape({
      isSignedIn: PropTypes.bool,
      vantageScore3: PropTypes.number
    }), PropTypes.shape({
      isSignedIn: PropTypes.bool,
      profiles: PropTypes.shape({
        tu_credit_report_profile: PropTypes.shape({
          vantage_score_3: PropTypes.number
        })
      })
    })]),
    legacyTrkProps: PropTypes.shape({
      trkPageType: PropTypes.string,
      trkTaxonomy: PropTypes.shape({
        /** Taxonomy page type. */
        pageType: PropTypes.string,
        /** Taxonomy topic. */
        topic: PropTypes.string,
        /** Taxonomy vertical. */
        vertical: PropTypes.string
      })
    }),
    omitRating: PropTypes.bool,
    reviewLinkOverride: PropTypes.string,
    showMatchScoreCTA: PropTypes.bool,
    showNotYetRated: PropTypes.bool,
    shouldOmitCreditScoreDriver: PropTypes.bool
  };
}
GqlKetoCardDrivers.defaultProps = {
  analytics: {}
};
GqlKetoCardDrivers.fragment = (0, _apollo.gql)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  fragment GqlKetoCardDrivers on MarketplaceEntityInterface {\n    ... on CreditCardsOfferV2 {\n      creditScoreComparisonContent {\n        relativeScoreLabel\n        scoreToCompare\n        pointDifference\n      }\n      maxFico\n      minFico\n      recommendedCreditScoreRangeDetails {\n        creditScoreRange\n        description\n      }\n    }\n    ... on MarketplaceEntityWithPlacementInterface {\n      placementDrivers {\n        description\n        label\n        value\n\n        ... on EntityPlacementDriver {\n          valueTooltip\n          valueTooltipHasHtml\n        }\n      }\n    }\n    ... on MarketplaceEntityWithStarRatingInterface {\n      starRating\n    }\n    ...MarketplaceStarRating\n  }\n  ", "\n"])), _reactMarketplaceStarRating.GraphQlMarketplaceStarRating.fragment);
var KetoCardDrivers = function KetoCardDrivers(_ref4) {
  var analytics = _ref4.analytics,
    className = _ref4.className,
    drivers = _ref4.drivers,
    enableAnalytics = _ref4.enableAnalytics,
    wrapDrivers = _ref4.wrapDrivers,
    isLTODynamicPlacement = _ref4.isLTODynamicPlacement;
  (0, _deprecate.useDeprecatedPropsWarning)({
    component: 'KetoQuickFacts',
    deprecatedProps: [{
      version: '6.9.0',
      deprecated: 'enableAnalytics',
      migration: 'Use analytics instead.'
    }],
    props: {
      enableAnalytics: enableAnalytics
    }
  });
  if ((0, _isEmpty3.default)(drivers)) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, wrapDrivers ? /*#__PURE__*/_react.default.createElement("div", {
    className: _ketoProductCardModule.default.wrappedDrivers
  }, drivers.map(function (driver) {
    return /*#__PURE__*/_react.default.createElement(KetoQuickFacts, {
      analytics: analytics,
      enableAnalytics: enableAnalytics || !(0, _isEmpty3.default)(analytics),
      key: driver.id,
      quickFacts: [driver]
    });
  })) : /*#__PURE__*/_react.default.createElement(KetoQuickFacts, {
    analytics: analytics,
    enableAnalytics: enableAnalytics,
    quickFacts: drivers,
    isLTODynamicPlacement: isLTODynamicPlacement
  }));
};
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var _PropTypes = require('prop-types');
  KetoCardDrivers.propTypes = {
    analytics: _PropTypes.shape({
      entityName: _PropTypes.string
    }),
    className: _PropTypes.string,
    drivers: _PropTypes.arrayOf(_PropTypes.shape(_reactQuickFacts.default.PropTypes)),
    /** @deprecated A flag indicating to send analytics */
    enableAnalytics: _PropTypes.bool,
    wrapDrivers: _PropTypes.bool,
    isLTODynamicPlacement: _PropTypes.bool
  };
}
KetoCardDrivers.defaultProps = {
  analytics: {},
  drivers: [],
  wrapDrivers: false,
  isLTODynamicPlacement: false
};
var _default = KetoCardDrivers;
exports.default = _default;